export default __webpack_public_path__ + "static/media/trusted-by-millions.5243941a.svg";